import clsx from 'clsx';

import { Flex, type FlexProps } from '@commons/containers/Flex';

/**
 * ColumnsSectionColumnRegion component.
 */

const ColumnsSectionColumnRegion = (props: FlexProps) => {
  const { children, className, ref, ...rest } = props;

  const classes = clsx('column', className);

  return (
    <Flex ref={ref} direction="column" className={classes} {...rest}>
      {children}
    </Flex>
  );
};

export default ColumnsSectionColumnRegion;
